import { FormValues } from "./types";

interface Params {
  values: FormValues;
}

type FVKeys = { [P in keyof FormValues]: boolean };
type Exclude =
  | "accounts"
  | "firstName"
  | "lastName"
  | "dateOfBirth"
  | "mobileNumber"
  | "relationship"
  | "products1"
  | "products2"
  | "products3"
  | "action"
  | "other";

export const showFormFields = ({ values }: Params): Omit<FVKeys, Exclude> => {
  const hasAdd = values.action === "add";
  const hasRemove = values.action === "remove";
  const hasAddWithAuthority =
    hasAdd && values.organisationOrFinancialCounsellor !== "";
  const hasAddWithAuthorityWithNoThirdParty =
    hasAddWithAuthority && values.organisationOrFinancialCounsellor === "no";

  const addingPoaGuardianOrAdministrator = hasAdd;
  const authorityLevel = hasAdd;
  const organisationOrFinancialCounsellor = hasAdd;

  const primaryContact =
    hasAdd && values.authorityLevel === "authority_to_maintain";

  const address = hasAdd;
  const suburb = hasAdd;
  const state = hasAdd;
  const postcode = hasAdd;
  const dateOfBirth2 = hasAdd;
  const email = hasAdd;
  const contactNumber = hasRemove || hasAddWithAuthority;
  const removalType = hasRemove;
  const nominatedFullName =
    hasAddWithAuthorityWithNoThirdParty ||
    (hasRemove &&
      (values.removalType === "nominated_third_party_" ||
        values.removalType === "no_remove"));
  const contactName =
    (hasAdd && values.organisationOrFinancialCounsellor === "yes") ||
    (hasRemove && values.removalType === "yes_remove");
  const organisationOrFinancialCounsellorsName = contactName;

  return {
    addingPoaGuardianOrAdministrator,
    authorityLevel,
    organisationOrFinancialCounsellor,
    contactNumber,
    contactName,
    dateOfBirth2,
    address,
    suburb,
    state,
    postcode,
    email,
    removalType,
    nominatedFullName,
    organisationOrFinancialCounsellorsName,
    primaryContact,
  };
};
